// 百合商城

export default [
  {
    path: '/mall',
    name: 'mall',
    component: () => import('@/views/mall/index.vue'),
  },
]
